import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid, Box } from "@mui/material";
import { API_BASE_URL } from "../../config/constants";
import CustomDatePicker from "./../../utility-v1/CustomDatePicker";
import SalesRecord from "./SalesRecord";
import GenerateLabel from "./GenerateLabel";

const ShippedItems = () => {
  const [profitStartDate, setProfitStartDate] = useState("");
  const [profitEndDate, setProfitEndDate] = useState("");
  const [salesData, setSalesData] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setDefaultDateRanges();
  }, []);

  const setDefaultDateRanges = () => {
    const today = new Date();
    const last30Days = new Date(today);
    last30Days.setDate(today.getDate() - 30);

    setProfitStartDate(last30Days.toISOString().split("T")[0]);
    setProfitEndDate(today.toISOString().split("T")[0]);
  };

  useEffect(() => {
    if (profitStartDate && profitEndDate) {
      fetchSalesReport(profitStartDate, profitEndDate);
    }
  }, [profitStartDate, profitEndDate]);

  const fetchSalesReport = (fromDate, toDate) => {
    axios
      .get(
        `${API_BASE_URL}/salesreport?from=${fromDate}&to=${toDate}&status=SD`
      )
      .then((response) => groupSalesById(response.data))
      .catch((error) => console.error("Error fetching sales data:", error));
  };

  const handleRevert = (salesId) => {
    const confirmRevert = window.confirm(
      "Are you sure you want to revert this sale back to Pending status?"
    );

    if (!confirmRevert) return; // Exit if user cancels

    axios
      .put(`${API_BASE_URL}/sales/${salesId}/status`)
      .then(() => {
        setSalesData(
          (prevSales) => prevSales.filter((sale) => sale.sales_id !== salesId) // ✅ Remove from list
        );
      })
      .catch((error) => {
        console.error("Error reverting sale status:", error);
        alert("Error reverting sale status. Please try again.");
      });
  };

  const groupSalesById = (sales) => {
    const groupedSales = sales.reduce((acc, sale) => {
      if (!acc[sale.sales_id]) {
        acc[sale.sales_id] = {
          sales_id: sale.sales_id,
          sales_date: sale.sales_date,
          total_price: parseFloat(sale.total_price),
          name: sale.name,
          buyer_details: sale.buyer_details,
          pincode: sale.pincode,
          state: sale.state,
          phone_number: sale.phone_number,
          shipment_price: sale.shipment_price
            ? parseFloat(sale.shipment_price)
            : 0,
          sales_status: sale.sales_status,
          items: [],
        };
      }
      acc[sale.sales_id].items.push({
        item_label: sale.item_label,
        quantity: sale.quantity,
        image: sale.image,
      });

      return acc;
    }, {});

    setSalesData(Object.values(groupedSales));
  };

  return (
    <Box sx={{ p: 0 }}>
      <Grid container spacing={2} sx={{ mb: 2 }} justifyContent="center">
        <Grid item xs={6} sm={6}>
          <CustomDatePicker
            label="Start Date"
            value={profitStartDate}
            onChange={(e) => setProfitStartDate(e.target.value)}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <CustomDatePicker
            label="End Date"
            value={profitEndDate}
            onChange={(e) => setProfitEndDate(e.target.value)}
          />
        </Grid>
        {/* Generate Label Button */}

        <Grid item xs={12}>
          <SalesRecord
            salesData={salesData}
            rowsPerPage={10}
            onRevert={handleRevert} // ✅ Pass the revert function
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShippedItems;
